import React from 'react';
import Const from '../Const';
import TableOwnerShip from './Table';

class TabContent extends React.Component {
  getSchemaKey = () => {
    const { indexSelectTab } = this.props;
    const map = {
      [Const.table.marjorShareHolders]: Const.listTitleTableMajorShareHolders,
      [Const.table.boardOfDirectors]: Const.listTitleTableBOD,
    };
    return map[indexSelectTab];
  };

  getTableTitle = () => {
    const { indexSelectTab } = this.props;
    const map = {
      [Const.table.marjorShareHolders]:
        'ownerShip.listTitleTableMajorShareHolders',
      [Const.table.boardOfDirectors]: 'ownerShip.listTitleTableBOD',
    };
    return map[indexSelectTab];
  };

  render() {
    const { id, indexSelectTab } = this.props;
    return (
      <div className="body-tab-content d-flex flex-fill">
        <TableOwnerShip
          key={indexSelectTab}
          title={this.getTableTitle()}
          schemaKey={this.getSchemaKey()}
          indexSelectTab={this.props.indexSelectTab}
          id={id}
        />
      </div>
    );
  }
}

export default TabContent;
